<template>
	<v-form
		class="registration-form-step1"
		ref="form"
		v-model="valid"
		lazy-validation
		@submit.prevent="validateAndSubmit"
	>
		<v-row>
			<v-col cols="12">
				<v-text-field
					class="pt-0 email-field"
					v-model.trim="fields.user_login"
					:error-messages="field_errors.user_login"
					:rules="rules.login"
					:placeholder="placeHolderLogin"
					required
				/>
			</v-col>

			<v-col cols="12" class="pb-0">
				<v-text-field
					class="pt-0 password-field"
					:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
					:type="showPassword ? 'text' : 'password'"
					v-model="fields.user_password"
					:rules="rules.password"
					:error-messages="field_errors.password"
					:placeholder="placeHolderPassword"
					required
					@click:append="showPassword = !showPassword"
				/>
			</v-col>
			<v-col cols="12" class="text-center mb-4">
				<v-btn
					v-if="signUpButton"
					class="align-center px-11 py-6 registration-form-step1__submit"
					type="submit"
				>
					{{ signUpButton }}
				</v-btn>
			</v-col>
		</v-row>
	</v-form>
</template>

<script>
import Form from '@/mixins/Form'
import { mapGetters } from 'vuex'
import { ruleRequired, ruleEmailOrDigits, rulePassword } from '@/utils/rules'

export default {
	name: 'RegistrationFormStep1',
	mixins: [Form],

	props: {
		categorySettings: { type: Object, default: null },
		initFields: { type: Object, default: () => ({}) },
	},

	data() {
		return {
			fields: {
				user_login: '',
				user_password: '',
			},
			showPassword: false,
		}
	},

	computed: {
		...mapGetters('settings', ['login']),

		rules() {
			return {
				login: [
					(v) => ruleRequired(v) || 'This field is required.',
					(v) => ruleEmailOrDigits(v) || 'Enter your email or numbers.',
				],
				password: [
					(v) => ruleRequired(v) || 'This field is required.',
					(v) => rulePassword(v) || '5 characters, number and letter',
				],
			}
		},

		signUpButton() {
			return this.categorySettings?.signup_button || 'Sign Up'
		},

		placeHolderLogin() {
			return this.categorySettings?.email_title || 'E-mail или цифры'
		},

		placeHolderPassword() {
			return this.categorySettings?.password_title || 'Password'
		},
	},

	created() {
		if (Object.keys(this.initFields).length) {
			this.fields = { ...this.fields, ...this.initFields }
		}
	},

	methods: {
		submitForm() {
			return new Promise((resolve) => {
				this.$emit('submitStep1', this.fields)
				resolve()
			})
		},
	},
}
</script>

<style lang="scss">
.registration-form-step1 {
	&__submit {
		height: 50px !important;
		width: 100%;
		border-radius: 8px;
		font-size: 18px !important;
		font-weight: 700;
		color: #fff !important;
		line-height: 22px;
		text-transform: capitalize;
		background-color: var(--button-main-background-color) !important;
	}

	.theme--light.v-input input {
		color: #000;
	}

	.password-field,
	.email-field {
		input {
			padding-left: 10px;
			font-size: 13px;
			font-weight: 500;
			max-height: 50px;
		}
		.v-input__slot {
			border-bottom: 1px solid rgba(0, 0, 0, 0.6);
		}
	}

	.theme--light.v-text-field > .v-input__control > .v-input__slot:before {
		color: #e5e5e5;
		border-color: #e5e5e5;
	}

	.password-field .v-input__append-inner .v-icon {
		color: #e5e5e5;
		padding: 30px 0 20px;
	}

	input::placeholder {
		color: #9b9b9b !important;
		opacity: 1;
	}
}
</style>
